import logo from './logo.svg';
import { Link } from "react-router-dom";
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


// const Home = lazy(() => import('./Home'));
// const About = lazy(() => import('./About'));


function App() {
  return (
    <>
      {/* <Router>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
      </Routes>
  </Router> */}


      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-dark-grayscale">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 0.49803921568627" />
              <feFuncG type="table" tableValues="0 0.49803921568627" />
              <feFuncB type="table" tableValues="0 0.49803921568627" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-grayscale">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-purple-yellow">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR
                type="table"
                tableValues="0.54901960784314 0.98823529411765"
              />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB
                type="table"
                tableValues="0.71764705882353 0.25490196078431"
              />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-blue-red">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 1" />
              <feFuncG type="table" tableValues="0 0.27843137254902" />
              <feFuncB
                type="table"
                tableValues="0.5921568627451 0.27843137254902"
              />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-midnight">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0 0" />
              <feFuncG type="table" tableValues="0 0.64705882352941" />
              <feFuncB type="table" tableValues="0 1" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-magenta-yellow">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0.78039215686275 1" />
              <feFuncG type="table" tableValues="0 0.94901960784314" />
              <feFuncB
                type="table"
                tableValues="0.35294117647059 0.47058823529412"
              />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-purple-green">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR
                type="table"
                tableValues="0.65098039215686 0.40392156862745"
              />
              <feFuncG type="table" tableValues="0 1" />
              <feFuncB type="table" tableValues="0.44705882352941 0.4" />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 0 0"
        width={0}
        height={0}
        focusable="false"
        role="none"
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          overflow: "hidden"
        }}
      >
        <defs>
          <filter id="wp-duotone-blue-orange">
            <feColorMatrix
              colorInterpolationFilters="sRGB"
              type="matrix"
              values=" .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 .299 .587 .114 0 0 "
            />
            <feComponentTransfer colorInterpolationFilters="sRGB">
              <feFuncR type="table" tableValues="0.098039215686275 1" />
              <feFuncG type="table" tableValues="0 0.66274509803922" />
              <feFuncB
                type="table"
                tableValues="0.84705882352941 0.41960784313725"
              />
              <feFuncA type="table" tableValues="1 1" />
            </feComponentTransfer>
            <feComposite in2="SourceGraphic" operator="in" />
          </filter>
        </defs>
      </svg>
      <div className="cursor js-cursor" />
      <div className="preloader" style={{ background: "#000000 !important" }}>
        <div className="layers">
          {" "}
          <span /> <span /> <span />{" "}
        </div>
        {/* end layers */}
        <div className="container-fluid">
          <figure>
            <img
              src="wp-content/uploads/2021/07/cropped-Favicon-32x32.png"
              alt="Swapplug"
            />
          </figure>
          <small data-splitting="">Plugging you in...</small>
          <div className="percentage">
            <div id="percentage" />
          </div>
          {/* end percentage */}
          <div className="loadbar" />
          {/* end loadbar */}
        </div>
        {/* end container-fluid */}
      </div>
      <div className="page-transition">
        <div className="layers">
          {" "}
          <span /> <span /> <span />{" "}
        </div>
        {/* end layers */}
      </div>
      {/* end page-transition */}
      <div className="menu-navigation">
        <div className="layers">
          {" "}
          <span /> <span /> <span />{" "}
        </div>
        {/* end layers */}
      </div>
      <nav className="topbar">
        <div className="logo">
          {" "}
          <a href="/" rel="home">
            {" "}
            <img
              src="./wp-content/uploads/2021/07/Logo-Long-2.png"
              srcSet="./wp-content/uploads/2021/07/Logo-Long.png"
              alt="Swapplug"
            />{" "}
          </a>{" "}
        </div>
        <div className="hamburger-menu">
          <div className="texts">
            {" "}
            <b data-splitting="">Menu</b> <b data-splitting="">Close</b>{" "}
          </div>
          {/* end texts */}
          <div className="svg circle" id="hamburger-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={70}
              height={70}
              viewBox="0 0 200 200"
            >
              <g strokeWidth="6.5" strokeLinecap="round">
                <path
                  d="M72 82.286h28.75"
                  fill="#009100"
                  fillRule="evenodd"
                  stroke="#fff"
                />
                <path
                  d="M100.75 103.714l72.482-.143c.043 39.398-32.284 71.434-72.16 71.434-39.878 0-72.204-32.036-72.204-71.554"
                  fill="none"
                  stroke="#fff"
                />
                <path
                  d="M72 125.143h28.75"
                  fill="#009100"
                  fillRule="evenodd"
                  stroke="#fff"
                />
                <path
                  d="M100.75 103.714l-71.908-.143c.026-39.638 32.352-71.674 72.23-71.674 39.876 0 72.203 32.036 72.203 71.554"
                  fill="none"
                  stroke="#fff"
                />
                <path
                  d="M100.75 82.286h28.75"
                  fill="#009100"
                  fillRule="evenodd"
                  stroke="#fff"
                />
                <path
                  d="M100.75 125.143h28.75"
                  fill="#009100"
                  fillRule="evenodd"
                  stroke="#fff"
                />
              </g>
            </svg>
          </div>
          {/* end svg */}
        </div>
        <div className="horizontal-menu">
          <div className="menu-top-menu-container">
            <ul id="menu-top-menu" className="horizontal-main-menu">

              <li
                itemScope="itemscope"
                itemType="https://www.schema.org/SiteNavigationElement"
                id="menu-item-2176"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2177 nav-item"
              >
                <a target="_blank"
                  title="MESSAGE US" href="mailto:hello@useswapplug.com" className="nav-link"
                >
                  MESSAGE US
                </a>

              </li>

              <li
                itemScope="itemscope"
                itemType="https://www.schema.org/SiteNavigationElement"
                id="menu-item-2177"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-2177 nav-item"
              >
                <a title="CALL" href="tel:+2348028418703" className="nav-link">
                  CALL US
                </a>
              </li>
              <li
                itemScope="itemscope"
                itemType="https://www.schema.org/SiteNavigationElement"
                id="menu-item-2178"
                className="playBtn menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-1824 current_page_item active menu-item-2178 nav-item"
              >
                <a
                  title="GET STARTED"
                  href='#'
                  className="nav-link"
                  aria-current="page"
                >
                  GET STARTED
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <main className="atheus-page">
        <div className="vc_row wpb_row vc_row-fluid">
          <div className="wpb_column vc_column_container vc_col-sm-12">
            <div className="vc_column-inner">
              <div className="wpb_wrapper">
                <header className="header hero-header">
                  <div className="showcase-slider">
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <div
                          className="slide-image bg-image"
                          style={{
                            backgroundImage: "url(" + "./wp-content/uploads/2019/03/Hero-Banner-devignedge%402x.png" + ")",
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                          }}
                        ></div>
                        <div
                          className="slide-image-mobile bg-image"
                          style={{
                            backgroundImage: "url(" + "./wp-content/uploads/2019/03/Hero-Banner-devignedge-%e2%80%93-1%402x.png" + ")",
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                          }}
                          data-background=""
                        ></div>
                        <div className="slide-inner">
                          <div className="container">
                            <small style={{ fontWeight: 'bold', fontSize: '20px' }} data-splitting="">SWAP - BUY - SELL </small>
                            <h1 data-splitting="">
                              Anything <br />
                              Anywhere
                            </h1>
                            <div className="link" onClick={() => document.querySelector('.stores_ div').classList.toggle('anime')}>
                              <a href="#" title="DOWNLOAD OUR APP">
                                <b>+</b>
                                <div className="words">
                                  <div className="first" data-splitting="">
                                    DOWNLOAD OUR APP
                                  </div>
                                  <div className="second" data-splitting="">
                                    DOWNLOAD OUR APP
                                  </div>
                                </div>

                                {/* end words */}
                              </a>
                              <div className='stores_'>
                                <div className='ele'>
                                  <span>
                                    <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M36.009,5.074H13.991C9.025,5.074,5,9.099,5,14.064V36c0,4.965,4.025,8.991,8.991,8.991h22.019	C40.975,44.99,45,40.965,45,36V14.064C45,9.099,40.975,5.074,36.009,5.074z M16.171,36.755c-0.372,0.636-1.041,0.989-1.728,0.989	c-0.343,0-0.691-0.088-1.009-0.274c-0.953-0.559-1.273-1.784-0.714-2.736l0.291-0.497c0.515-0.162,1.057-0.25,1.614-0.234l0.005,0	c1.023,0.03,1.879,0.493,2.464,1.176L16.171,36.755z M27.413,32H12c-1.104,0-2-0.896-2-2s0.896-2,2-2h4.665l5.866-10.01	l-1.811-3.091c-0.559-0.953-0.239-2.178,0.714-2.737c0.953-0.558,2.178-0.239,2.737,0.714l0.678,1.157l0.678-1.157	c0.558-0.953,1.783-1.272,2.737-0.714c0.953,0.559,1.273,1.784,0.714,2.737L21.301,28h4.18c0.625,0.416,1.162,0.966,1.549,1.64	l0.003,0.004C27.473,30.409,27.57,31.237,27.413,32z M38,32h-2.623l1.602,2.733c0.559,0.952,0.239,2.178-0.714,2.736	c-0.318,0.187-0.666,0.274-1.009,0.274c-0.687,0-1.355-0.354-1.728-0.989l-6.151-10.497c-0.834-1.549-0.803-3.427,0.109-4.943	l0.826-1.373L33.033,28H38c1.104,0,2,0.896,2,2S39.104,32,38,32z" /></svg>
                                  </span>

                                  <span
                                    onClick={() => window.open('https://play.google.com/store/apps/details?id=com.swapplug')}
                                  >
                                    <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 7.125 2 L 28.78125 23.5 L 34.71875 17.5625 L 8.46875 2.40625 C 8.03125 2.152344 7.5625 2.011719 7.125 2 Z M 5.3125 3 C 5.117188 3.347656 5 3.757813 5 4.21875 L 5 46 C 5 46.335938 5.070313 46.636719 5.1875 46.90625 L 27.34375 24.90625 Z M 36.53125 18.59375 L 30.1875 24.90625 L 36.53125 31.1875 L 44.28125 26.75 C 45.382813 26.113281 45.539063 25.304688 45.53125 24.875 C 45.519531 24.164063 45.070313 23.5 44.3125 23.09375 C 43.652344 22.738281 38.75 19.882813 36.53125 18.59375 Z M 28.78125 26.3125 L 6.9375 47.96875 C 7.300781 47.949219 7.695313 47.871094 8.0625 47.65625 C 8.917969 47.160156 26.21875 37.15625 26.21875 37.15625 L 34.75 32.25 Z" /></svg>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* end container */}
                        </div>
                        {/* end slide-inner */}
                      </div>
                      <div className="swiper-slide">
                        <div
                          className="slide-image bg-image secMine"
                          style={{
                            backgroundImage: "url(" + "./wp-content/uploads/2019/03/Hero-Banner-devignedge-%e2%80%93-2%402x.png" + ")",
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                          }}

                        ></div>
                        <div
                          className="slide-image-mobile bg-image"
                          style={{
                            backgroundImage: "url(" + "./wp-content/uploads/2019/03/Hero-Banner-devignedge-%e2%80%93-3%402x.png" + ")",
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                          }}

                        ></div>
                        <div className="slide-inner">
                          <div className="container cont_">
                            <small data-splitting="" style={{ fontWeight: 'bold', fontSize: '20px' }}>
                              {/* YOUR SECURED ONLINE MARKETPLACE */}
                              SWAP - BUY - SELL
                            </small>
                            <h1 data-splitting="" className="text_sizing">
                              YOUR SECURED ONLINE MARKETPLACE<br /> <b></b>{" "}
                            </h1>
                            <p className="aboutT">
                              Revolutionising Africa's e-commerce marketplace through secure trading. <br />

                              Swap Plug is an e-commerce platform that leverages blockchain technology to enable buyers and sellers make secure trades and transactions.<br />

                              Traders can use what they have to get what they want. Our trading platform allows users perform mutually beneficial and negotiated exchange transactions.<br />

                              We secure a warranty on the quality and legitimacy of the products you purchase. If a buy or swap fails to meet agreed standards, the next credit alert you receive will be your refund… No losses attached!
                            </p>
                            <div className="link link_" onClick={() => document.querySelector('.stores__ div').classList.toggle('anime_')}>
                              <a href="#" title="DOWNLOAD OUR APP">
                                <b>+</b>
                                <div className="words">
                                  <div className="first" data-splitting="">
                                    DOWNLOAD OUR APP
                                  </div>
                                  <div className="second" data-splitting="">
                                    DOWNLOAD OUR APP
                                  </div>
                                </div>
                                {/* end words */}
                              </a>
                              <div className='stores__'>
                                <div className='ele'>
                                  <span>
                                    <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M36.009,5.074H13.991C9.025,5.074,5,9.099,5,14.064V36c0,4.965,4.025,8.991,8.991,8.991h22.019	C40.975,44.99,45,40.965,45,36V14.064C45,9.099,40.975,5.074,36.009,5.074z M16.171,36.755c-0.372,0.636-1.041,0.989-1.728,0.989	c-0.343,0-0.691-0.088-1.009-0.274c-0.953-0.559-1.273-1.784-0.714-2.736l0.291-0.497c0.515-0.162,1.057-0.25,1.614-0.234l0.005,0	c1.023,0.03,1.879,0.493,2.464,1.176L16.171,36.755z M27.413,32H12c-1.104,0-2-0.896-2-2s0.896-2,2-2h4.665l5.866-10.01	l-1.811-3.091c-0.559-0.953-0.239-2.178,0.714-2.737c0.953-0.558,2.178-0.239,2.737,0.714l0.678,1.157l0.678-1.157	c0.558-0.953,1.783-1.272,2.737-0.714c0.953,0.559,1.273,1.784,0.714,2.737L21.301,28h4.18c0.625,0.416,1.162,0.966,1.549,1.64	l0.003,0.004C27.473,30.409,27.57,31.237,27.413,32z M38,32h-2.623l1.602,2.733c0.559,0.952,0.239,2.178-0.714,2.736	c-0.318,0.187-0.666,0.274-1.009,0.274c-0.687,0-1.355-0.354-1.728-0.989l-6.151-10.497c-0.834-1.549-0.803-3.427,0.109-4.943	l0.826-1.373L33.033,28H38c1.104,0,2,0.896,2,2S39.104,32,38,32z" /></svg>
                                  </span>

                                  <span
                                    onClick={() => window.open('https://play.google.com/store/apps/details?id=com.swapplug')}
                                  >
                                    <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px"><path d="M 7.125 2 L 28.78125 23.5 L 34.71875 17.5625 L 8.46875 2.40625 C 8.03125 2.152344 7.5625 2.011719 7.125 2 Z M 5.3125 3 C 5.117188 3.347656 5 3.757813 5 4.21875 L 5 46 C 5 46.335938 5.070313 46.636719 5.1875 46.90625 L 27.34375 24.90625 Z M 36.53125 18.59375 L 30.1875 24.90625 L 36.53125 31.1875 L 44.28125 26.75 C 45.382813 26.113281 45.539063 25.304688 45.53125 24.875 C 45.519531 24.164063 45.070313 23.5 44.3125 23.09375 C 43.652344 22.738281 38.75 19.882813 36.53125 18.59375 Z M 28.78125 26.3125 L 6.9375 47.96875 C 7.300781 47.949219 7.695313 47.871094 8.0625 47.65625 C 8.917969 47.160156 26.21875 37.15625 26.21875 37.15625 L 34.75 32.25 Z" /></svg>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* end container */}
                        </div>
                        {/* end slide-inner */}
                      </div>
                    </div>
                    <div className="swiper-pagination" />
                    {/* end swiper-pagination */}
                    <div className="swiper-controls">
                      <div className="swiper-button-prev">
                        {" "}
                        <span>HOME</span>{" "}
                      </div>
                      <div className="swiper-button-next">
                        {" "}
                        <span>ABOUT</span>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="bottombar">
                    <div className="social-media">
                      <ul data-splitting="">

                        <li>
                          <a
                            href="https://www.twitter.com/swapplug"
                            title="TWITTER"
                            target="_blank"
                            rel="noreferrer"
                          >
                            TWITTER
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/swapplug"
                            title="INSTAGRAM"
                            target="_blank"
                            rel="noreferrer"
                          >
                            INSTAGRAM
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.linkedin.com/swapplug"
                            title="LINKEDIN"
                            target="_blank"
                            rel="noreferrer"
                          >
                            LINKEDIN
                          </a>
                        </li>
                      </ul>
                      <div>
                        <p>© 2022 - Code Inclusive | Swapplug</p>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>

  );
}

export default App;
